import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, InjectedFormProps, reduxForm, stopSubmit, touch, } from 'redux-form';
import { Button } from 'reactstrap';
// import "../../PortalPage/portalPage.scss";
import { Row, Col } from 'reactstrap';
import {
  CaseNotificationsEnum,
  CasePrePostEnum,
  CaseTaskEnum,
  ICaseDetailsModel,
  ICaseTaskDetailsList,
  ICaseTaskModel,
  ICaseTaskNotificationModel,
  TaskStatusEnum
} from '../../../models/Cases/CaseDetailsModel';
import { catchError } from '../../../utils/Utils';
import validate from "./CaseTaskValidate"
import { transformUTCDateWithoutTime } from '../../../utils/dateUtil';
import { TextField } from 'common-fields/dist/esm/components';
import normalizeTextarea from '../../../utils/NormalizeTextarea';
import SelectField from '../../../commonfields/SelectField';
import MultipleSelectField from '../../../commonfields/MultipleSelectField';
import FutureDatePicker from '../../../commonfields/FutureDatePicker';
import Service from '../../../services';
import { BankUserContext } from '../../../bankUserContext';
import React from 'react';

export interface ITaskFormProps {
  caseDetails: ICaseDetailsModel | null;
  selectedTask: ICaseTaskModel | null;
  setSelectedTask: (value: ICaseTaskModel | null) => void;
  createTaskHandler: (values: any) => void;
  verifyTask: (values: any, init?: boolean) => Promise<void>
  loader: boolean;
  displayVerifySuccess: boolean;
  setDisplayVerifySuccess: (value: boolean) => void;
  verifyErrors: any;
}


const TaskForm: React.FC<ITaskFormProps &
  InjectedFormProps<Record<string, unknown>, ITaskFormProps>> = (props: any) => {
    const service = useMemo(() => new Service(), []);
    const {
      invalid,
      caseDetails,
      selectedTask,
      createTaskHandler,
      verifyTask,
      loader,
      displayVerifySuccess,
      setDisplayVerifySuccess,
      verifyErrors
    } = props;
    const context = React.useContext(BankUserContext);
    const [allManualTodoUsers, setAllManualTodoUsers] = useState([]);
    const [predecessorsData, setPredecessorsData] = useState<any>([]);
    const [successorsData, setSuccessorsData] = useState<any>([]);
    const [init, setInit] = useState(true);

    useEffect(() => {
      if (displayVerifySuccess) {
        setTimeout(() => setDisplayVerifySuccess(false), 5000)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayVerifySuccess])

    const getCaseTaskListByCaseId = (value: string | number, taskId?: string | null) => {
      caseDetails && service.getCaseTaskListByCaseId(caseDetails?.caseId, value, taskId)
        .then((res) => {
          if (res?.data) {
            const mapData = res?.data?.map((each: ICaseTaskModel) => ({
              text: each?.title,
              value: each?.taskId
            }))
            if (value === 0) setPredecessorsData(mapData)
            else setSuccessorsData(mapData)
          }
        }).catch(err => catchError(err, true))
    }

    const getAllManualTodoUsers = () => {
      service.getAllManualTodoUsers(context?.bankuserDetails?.organization?.orgId, 4).then((response: any) => {
        const data = response.data.map((element: any) => {
          return { text: `${element.firstName + " " + element.lastName}`, value: element.userId }
        })
        setAllManualTodoUsers(data)
      })
    }

    const predecessorsMap = useMemo(() => {
      const currentSuccessors = props?.selectedTask?.casePrePostTaskDetailsList?.filter(
        (each: any) => each?.type === CasePrePostEnum.SUCCESSOR
      )?.map((eachInner: any) => eachInner?.value) || [];
      const successors = props?.formValues?.successorTo?.map((each: any) => each?.value) || [];
      return predecessorsData?.filter((each: any) => ![...currentSuccessors, ...successors]?.includes(each?.value))
    }, [props?.selectedTask?.casePrePostTaskDetailsList, props?.formValues?.successorTo, predecessorsData])

    const successorsMap = useMemo(() => {
      const currentPredecessors = props?.selectedTask?.casePrePostTaskDetailsList?.filter(
        (each: any) => each?.type === CasePrePostEnum.SUCCESSOR
      )?.map((eachInner: any) => eachInner?.value) || [];
      const predecessors = props?.formValues?.predecessorTo?.map((each: any) => each?.value) || [];
      return successorsData?.filter((each: any) => ![...currentPredecessors, ...predecessors]?.includes(each?.value))
    }, [props?.selectedTask?.casePrePostTaskDetailsList, props?.formValues?.predecessorTo, successorsData])

    useEffect(() => {
      getAllManualTodoUsers();
      getCaseTaskListByCaseId(0, selectedTask?.taskId)
      getCaseTaskListByCaseId(1, selectedTask?.taskId)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [service])

    useEffect(() => {
      const errorsKey = verifyErrors && Object.keys(verifyErrors)
      if (init && errorsKey && errorsKey?.length > 0) {
        props?.dispatch(stopSubmit('TaskForm', verifyErrors))
        props?.dispatch(touch('TaskForm', ...errorsKey))
        setInit(false)
      }
    }, [init, props, verifyErrors])

    return (
      <div className="createCaseForm">
        <form onSubmit={props.handleSubmit(createTaskHandler)} className="form-group">
          {
            !props?.fromViewDetails &&
            <Row>
              <Col>
                <div className='leftInput'>
                  <Field
                    component={TextField}
                    isRequired={true}
                    type="text"
                    name={'title'}
                    label="Task Title"
                    HelpText={"Task Title"}
                    disabled={props?.disableFields || selectedTask?.status === TaskStatusEnum.IN_PROGRESS}
                    normalize={normalizeTextarea}
                  />
                </div>
              </Col>
              <Col>
                <div className='rightInput'>
                  <Field
                    component={SelectField}
                    isRequired={true}
                    name={"assignedTo"}
                    label={"Assign To"}
                    HelpText={"Assign To"}
                    values={allManualTodoUsers}
                    disabled={props?.disableFields || selectedTask?.status === TaskStatusEnum.IN_PROGRESS}
                  />
                </div>
              </Col>
            </Row>
          }

          <Field
            component={TextField}
            isRequired={true}
            name={"description"}
            label={`Description (${props?.formValues?.description?.length || 0}/1000)`}
            type="textarea"
            maxlength={1000}
            disabled={props?.disableFields || selectedTask?.status === TaskStatusEnum.IN_PROGRESS}
            normalize={normalizeTextarea}
          />

          {(!selectedTask || selectedTask?.type === CaseTaskEnum.TASK) ? <Row>
            <Col>
              <div className='leftInput'>
                <Field
                  component={MultipleSelectField}
                  isRequired={true}
                  type="text"
                  name={'predecessorTo'}
                  label={"Predecessor"}
                  HelpText={"Predecessor"}
                  values={predecessorsMap}
                  disabled={props?.disableFields || selectedTask?.status === TaskStatusEnum.IN_PROGRESS}
                />
              </div>
            </Col>
            <Col>
              <div className='rightInput'>
                <Field
                  component={MultipleSelectField}
                  isRequired={true}
                  name={"successorTo"}
                  label="Successor"
                  HelpText={"Successor"}
                  values={successorsMap}
                  disabled={props?.disableFields}
                />
              </div>
            </Col>
          </Row> : <></>}

          <Col md="12" className="dueDateCol">
            <label className="form-label">
              Due Date{<span className="input-required">*</span>}
            </label>
            <Field
              disabled={props?.disableFields || selectedTask?.type === CaseTaskEnum.CLOSING_TASK}
              isRequired={true}
              name={"dueDate"}
              component={FutureDatePicker}
              valuedata={null}
              minDate={new Date()}
              showYearDropdown
              autoComplete="off"
            />
          </Col>

          <Row>
            <Col>
              <div className='leftInput'>
                <Field
                  component={MultipleSelectField}
                  // isRequired={true}
                  type="text"
                  name={'reachingDueDateNotificatonId'}
                  label="Reaching Due Date Notification"
                  HelpText={"reachingDueDateNotification"}
                  values={allManualTodoUsers}
                  flip={true}
                  disabled={props?.disableFields || selectedTask?.status === TaskStatusEnum.IN_PROGRESS}
                />
              </div>
            </Col>
            <Col>
              <div className='rightInput'>
                <Field
                  component={MultipleSelectField}
                  // isRequired={true}
                  name={"completionNotificationId"}
                  label={"Completion Notification"}
                  HelpText={"completionNotification"}
                  values={allManualTodoUsers}
                  disabled={props?.disableFields || selectedTask?.status === TaskStatusEnum.IN_PROGRESS}
                  flip={true}
                />
              </div>
            </Col>
          </Row>

          <div className="buttonContainer">
            <Button
              disabled={invalid || props?.disableFields || loader}
              className="createButton verifyButton"
              onClick={props.handleSubmit(verifyTask)}
            >
              Verify
            </Button>

            <Button
              disabled={invalid || props?.disableFields || loader}
              className="createButton"
            >
              {selectedTask ? "Update" : "Create"}
            </Button>
          </div>

          {displayVerifySuccess ?
            <div className="no-conflicts">No conflicts found</div>
            : <></>}

        </form>
      </div>
    );
  }

export default connect((state: Record<string, unknown>, props: ITaskFormProps) => {
  return {
    initialValues: {
      caseId: props?.caseDetails?.caseId,
      title: props?.selectedTask?.title || '',
      assignedTo: props?.selectedTask?.assignedTo || '',
      description: props?.selectedTask?.description || '',
      predecessorTo:
        props?.selectedTask?.casePrePostTaskDetailsList?.filter(each => each?.type === CasePrePostEnum.PREDECESSOR)
          .map((item: ICaseTaskDetailsList) => {
            return { text: item?.title, value: item?.taskId };
          }),
      successorTo:
        props?.selectedTask?.casePrePostTaskDetailsList?.filter(each => each?.type === CasePrePostEnum.SUCCESSOR)
          .map((item: ICaseTaskDetailsList) => {
            return { text: item?.title, value: item?.taskId };
          }),
      dueDate: props?.selectedTask?.dueDate ? transformUTCDateWithoutTime(props?.selectedTask?.dueDate) : '',
      reachingDueDateNotificatonId:
        props?.selectedTask?.caseNotifications?.filter(each => each?.type === CaseNotificationsEnum.DUE)
          .map((item: ICaseTaskNotificationModel) => {
            return { text: item?.userName, value: item?.userId };
          }),
      completionNotificationId:
        props?.selectedTask?.caseNotifications?.filter(each => each?.type === CaseNotificationsEnum.COMPLETION)
          .map((item: ICaseTaskNotificationModel) => {
            return { text: item?.userName, value: item?.userId };
          }),
    },
    formValues: getFormValues("TaskForm")(state),
  };
})(
  reduxForm<Record<string, unknown>, ITaskFormProps>({
    form: "TaskForm",
    enableReinitialize: true,
    validate,
  })(TaskForm)
);
